<mat-sidenav-container class="admin-container">
  <mat-sidenav mode="side" opened class="admin-sidenav">
    <mat-toolbar color="primary" class="sidenav-toolbar">Admin Panel</mat-toolbar>
    <mat-nav-list>
      <a mat-list-item href="#" (click)="$event.preventDefault(); safeGetUsers(); selectedSection='users'; onChangeSecction();" [attr.aria-current]="selectedSection==='users' ? 'page' : null">Users</a>
      <a mat-list-item href="#" (click)="$event.preventDefault(); safeGetCompanies(); selectedSection='company'; onChangeSecction();" [attr.aria-current]="selectedSection==='company' ? 'page' : null">Company</a>
      <a mat-list-item href="#" (click)="$event.preventDefault(); safeGetDataservices(); selectedSection='dataservices'; onChangeSecction();" [attr.aria-current]="selectedSection==='dataservices' ? 'page' : null">Data Services</a>
      <a mat-list-item href="#" (click)="$event.preventDefault();  selectedSection='settings'; onChangeSecction();" [attr.aria-current]="selectedSection==='settings' ? 'page' : null">Settings</a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    @if (!isLoading) {
      <mat-toolbar color="primary" class="top-toolbar">
      <span>{{this.panelTitle}}</span>
      <span class="spacer"></span>
    </mat-toolbar>

    <div class="content">
      <mat-card *ngIf="selectedSection==='users'">
        <mat-card-content>
          <div class="controls controls-search">
            <mat-form-field appearance="outline" class="search-field">
              <!-- <mat-label>Search users</mat-label> -->
              <input matInput (keyup.enter)="callUserList()" placeholder="Name or email" [value]="filterValue" [(ngModel)]="filterValue" />
              <button matSuffix mat-icon-button aria-label="Clear" *ngIf="filterValue" (click)="clearFilter()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <button mat-flat-button color="primary" (click)="onAddUser()">
              <mat-icon>person_add</mat-icon>
              Add
            </button>
          </div>

          <div class="table-wrapper">
            <table mat-table [dataSource]="dataSource" [trackBy]="trackById" class="mat-elevation-z2">
              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
              </ng-container>

              <!-- Email Column -->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Email</th>
                <td mat-cell *matCellDef="let element">{{ element.email }}</td>
              </ng-container>

              <ng-container matColumnDef="country">
                <th mat-header-cell *matHeaderCellDef>Country</th>
                <td mat-cell *matCellDef="let element">{{ element.country }}</td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button aria-label="More Actions" [matMenuTriggerFor]="userMenu" (click)="selectUser(element)">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>

          <pagination #userPaginationComponent [pagination]="usersPagination" [dataSource]="getUsersList"></pagination>

        </mat-card-content>
      </mat-card>

      <mat-card *ngIf="selectedSection==='company'">
        <mat-card-content>
          <div class="controls controls-search">
            <mat-form-field appearance="outline" class="search-field">
              <!-- <input matInput (keyup)="applyCompanyFilter($event)" placeholder="ID or name" /> -->
              <input matInput (keyup.enter)="callCompaniesList()" placeholder="ID or name" [value]="companyFilterValue" [(ngModel)]="companyFilterValue" />
              <button matSuffix mat-icon-button aria-label="Clear" *ngIf="companyFilterValue" (click)="clearCompanyFilter()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <button mat-flat-button color="primary" (click)="onAddCompany()">
              <mat-icon>business</mat-icon>
              Add
            </button>
          </div>

          <div class="table-wrapper">
            <table mat-table [dataSource]="companyDataSource" [trackBy]="trackByCompanyId" class="mat-elevation-z2">
              <!-- ID Column -->
              <ng-container matColumnDef="company_id">
                <th mat-header-cell *matHeaderCellDef>ID</th>
                <td mat-cell *matCellDef="let element">{{ element.id }}</td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="company_name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
              </ng-container>

              <!-- Country Column -->
              <ng-container matColumnDef="country_head_quarters">
                <th mat-header-cell *matHeaderCellDef>HQ Country</th>
                <td mat-cell *matCellDef="let element">{{ element.country }}</td>
              </ng-container>

              <!-- Description Column -->
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let element">{{ element.description }}</td>
              </ng-container>

              <!-- Actions Column -->
              <!-- <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button color="warn" aria-label="Delete company">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container> -->

              <tr mat-header-row *matHeaderRowDef="companyDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: companyDisplayedColumns"></tr>
            </table>
          </div>

          <pagination #companiesPaginationComponent [pagination]="companiesPagination" [dataSource]="getCompaniesList"></pagination>

        </mat-card-content>
      </mat-card>

      <mat-card *ngIf="selectedSection==='dataservices'">
        <mat-card-content>
          <div class="controls controls-search">
            <mat-form-field appearance="outline" class="search-field">
              <input matInput (keyup.enter)="callDataservicesList()" placeholder="Search by any field" [value]="dataServiceFilterValue" [(ngModel)]="dataServiceFilterValue"/>
              <button matSuffix mat-icon-button aria-label="Clear" *ngIf="dataServiceFilterValue" (click)="clearDataServiceFilter()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <button mat-flat-button color="primary" (click)="onAddDataService()">
              <mat-icon>add</mat-icon>
              Add
            </button>
          </div>

          <div class="table-wrapper">
            <table mat-table [dataSource]="dataServiceDataSource" [trackBy]="trackByDataServiceId" class="mat-elevation-z2">
              <ng-container matColumnDef="company_id">
                <th mat-header-cell *matHeaderCellDef>Company ID</th>
                <td mat-cell *matCellDef="let element">{{ element.company_id }}</td>
              </ng-container>

              <ng-container matColumnDef="dataservice_id">
                <th mat-header-cell *matHeaderCellDef>Service ID</th>
                <td mat-cell *matCellDef="let element">{{ element.id }}</td>
              </ng-container>

              <ng-container matColumnDef="dataservice_name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
              </ng-container>

              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <td mat-cell *matCellDef="let element">{{ element.type }}</td>
              </ng-container>

              <ng-container matColumnDef="contact">
                <th mat-header-cell *matHeaderCellDef>Contact</th>
                <td mat-cell *matCellDef="let element">{{ element.contact }}</td>
              </ng-container>

              <ng-container matColumnDef="phone">
                <th mat-header-cell *matHeaderCellDef>Phone</th>
                <td mat-cell *matCellDef="let element">{{ element.phone }}</td>
              </ng-container>

              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let element">{{ element.description }}</td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button aria-label="More Actions" [matMenuTriggerFor]="dataserviceMenu" (click)="selectDataservice(element)">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="dataServiceDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: dataServiceDisplayedColumns"></tr>
            </table>
          </div>
          <pagination #dataservicesPaginationComponent [pagination]="dataservicePagination" [dataSource]="getDataServiceList"></pagination>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-content *ngIf="selectedSection==='settings'">

        </mat-card-content>
      </mat-card>

      <mat-menu #userMenu="matMenu">
        <button mat-menu-item (click)="onModifyUser()">Modify User</button>
        <button mat-menu-item (click)="onAddRole()">Add Permissions</button>
        <button mat-menu-item (click)="onAddSchemaPermissions()">Add Schema Permissions</button>
        <button mat-menu-item (click)="onAddUserCompany()">Add to Company</button>
        <button mat-menu-item (click)="onAddUserDataService()">Add to Data Service</button>
      </mat-menu>

      <mat-menu #dataserviceMenu="matMenu">
        <button mat-menu-item (click)="configModelTree()">Config Model Tree</button>
      </mat-menu>

      
    </div>
    }@else {
      <div class="d-flex justify-content-center align-items-center">
        <mat-progress-spinner class="custom-spinner" mode="indeterminate"></mat-progress-spinner>
      </div>
    }
  </mat-sidenav-content>
</mat-sidenav-container>
